// Generated by CoffeeScript 1.12.7
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/rating',['require','underscore','../question_form','../../check_radio','nouislider'],function(require) {
  var CheckRadio, QuestionForm, Rating, _, noUiSlider;
  _ = require('underscore');
  QuestionForm = require('../question_form');
  CheckRadio = require("../../check_radio");
  noUiSlider = require('nouislider');
  return Rating = (function(superClass) {
    extend(Rating, superClass);

    function Rating() {
      return Rating.__super__.constructor.apply(this, arguments);
    }

    Rating.prototype.tagName = "ul";

    Rating.slider = null;

    Rating.prototype.initialize = function(options) {
      return Rating.__super__.initialize.call(this, options);
    };

    Rating.prototype.render = function() {
      var labels;
      Rating.__super__.render.call(this);
      labels = this.model.get('properties').order ? this.setOrder(this.model.get('properties').order) : this.model.get('properties').labels;
      if (labels) {
        if (this.model.get('properties').layout && this.model.get('properties').layout === 'slider') {
          this.renderSlider(labels);
        } else {
          this.renderChoices(labels);
        }
        if (this.model.get('properties').layout) {
          this.setLayout();
        }
      }
      return this.el;
    };

    Rating.prototype.renderSlider = function(labels) {
      var $labelContainer, $labels, incremental, max, min, vals;
      vals = _.map(labels, function(label) {
        return _.toNumber(label.value);
      });
      if (vals.length > 1) {
        min = _.min(vals);
        max = _.max(vals);
        if (max === vals[0]) {
          labels.reverse();
          vals.reverse();
        }
        incremental = _.every(vals, function(item, index) {
          return item === (min + index);
        });
        if (max > min && incremental) {
          $labelContainer = $('<li>').addClass('slider-label-container').appendTo(this.$el);
          $labels = $('<ul>').addClass('slider-labels').appendTo($labelContainer);
          setTimeout(function() {
            var inc;
            inc = $labels.width() / (labels.length - 1);
            return _.each(labels, (function(_this) {
              return function(item, index) {
                var $li, $span, xPos;
                xPos = inc * index;
                $li = $("<li>").addClass('slider-label label').css({
                  left: xPos
                }).appendTo($labels);
                return $span = $("<span>").text(item.label).appendTo($li);
              };
            })(this));
          }, 200);
          this.slider = $('<li>').addClass('slider-container').appendTo(this.$el)[0];
          noUiSlider.create(this.slider, {
            start: this.values && this.values.length && this.values[0].value ? Number(this.values[0].value) : 0,
            step: 1,
            connect: 'lower',
            range: {
              min: min,
              max: max
            },
            cssPrefix: 'sp-slider-'
          });
          return this.slider.noUiSlider.on('set', (function(_this) {
            return function(strVals) {
              var val;
              val = Number(strVals.pop());
              val = _.find(_this.model.get('properties').labels, {
                value: val
              });
              if (val) {
                _this.values = [val];
                return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
              }
            };
          })(this));
        } else {
          return this.renderChoices(labels);
        }
      }
    };

    Rating.prototype.renderChoices = function(labels) {
      return _.each(labels, (function(_this) {
        return function(item, index) {
          var $input, $li, id;
          id = (_this.model.get("_id")) + "[" + index + "]";
          $li = $("<li>");
          $input = new CheckRadio("radio", item.label, {
            name: _this.model.get("_id"),
            id: id,
            value: item.value,
            'data-label': item.label
          }).render();
          $input.appendTo($li).change(function(e) {
            var $target, val;
            $target = $(e.target);
            val = _.find(_this.model.get('properties').labels, {
              label: String($target.data('label'))
            });
            if (val) {
              _this.values = [val];
              return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
            }
          });
          return _this.$el.append($li);
        };
      })(this));
    };

    Rating.prototype.setOrder = function(order) {
      var labels;
      return labels = (function() {
        switch (order) {
          case 'random':
            return _.shuffle(this.model.get('properties').labels);
          case 'desc_value':
            return _.sortBy(this.model.get('properties').labels, function(item) {
              return -Number(item.value);
            });
          case 'asc_value':
            return _.sortBy(this.model.get('properties').labels, function(item) {
              return Number(item.value);
            });
          case 'desc_title':
            return _.sortBy(this.model.get('properties').labels, function(item) {
              return item.label;
            }).reverse();
          case 'asc_title':
            return _.sortBy(this.model.get('properties').labels, function(item) {
              return item.label;
            });
          default:
            return this.model.get('properties').labels;
        }
      }).call(this);
    };

    Rating.prototype.sort = function(order) {
      var $inputItems;
      $inputItems = this.$el.children("li");
      return $inputItems.detach().compare(function(a, b) {});
    };

    Rating.prototype.setValues = function(vals) {
      if (vals && _.isArray(vals) && typeof vals[0] !== 'undefined' && vals[0] !== null) {
        if (this.model.get('properties').layout && this.model.get('properties').layout === 'slider') {
          if (this.slider && this.slider.noUiSlider) {
            return this.slider.noUiSlider.set(vals[0].value);
          }
        } else {
          return this.$el.find('label.radio').each(function(index, item) {
            var $item;
            $item = $(item);
            if ($item.find('.label').text() === vals[0].label) {
              return $item.find('input').prop('checked', true).trigger('change');
            }
          });
        }
      }
    };

    return Rating;

  })(QuestionForm);
});

